import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useScreenSize } from "../../hooks/useScreenSize";
import { Phone, Mail } from "lucide-react";
import KeurwijzerPopup from "../../componentsNew/trust-badge/trustBadge";

const Nav = () => {
  const [loading] = useState(false);
  const [error] = useState<string | null>(null);
  const { isTablet } = useScreenSize();

  const location = useLocation();
  const isActive = (path: string): boolean => location.pathname === path;

  return (
    <section className="grid-padding-lr">
      <nav className="navbar">
        <div className="flex-row gap-2 w-100">
          <div className="flex-row space-between w-100">
            <div
              className={`${isTablet ? "navbar-logo-small" : "navbar-logo"}`}
            >
              <Link to="/">
                {loading ? (
                  <p>Loading...</p>
                ) : error ? (
                  <p style={{ color: "red" }}>{error}</p>
                ) : (
                  <img
                    src={require("../../images/logo/logoLight.webp")}
                    alt="Logo"
                  />
                )}
              </Link>
              <KeurwijzerPopup />
            </div>
            {/* Navbar Links */}
            <ul className="navbar-desktop flex-row-align justify-end w-100">
              <li className={isActive("/diensten") ? "active" : ""}>
                <Link to="/diensten">Diensten</Link>
              </li>
              <li className={isActive("/realisaties") ? "active" : ""}>
                <Link to="/realisaties">Referenties</Link>
              </li>
              <li className={isActive("/overons") ? "active" : ""}>
                <Link to="/overons">Over Ons</Link>
              </li>
              <li className={isActive("/contact") ? "active" : ""}>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
            <ul className="flex-row-align">
              <a href="tel:+32 0478 36 60 70" aria-label="Phone">
                <Phone size={20} color="#fff" />
              </a>
              <a href="mailto:info@decoratiedegezelle.be" aria-label="Email">
                <Mail size={20} color="#fff" />
              </a>
            </ul>
          </div>
        </div>
      </nav>
    </section>
  );
};

export default Nav;
